import type { AccountFn } from "../types";

/**
 * Tries to get account based on function fn
 * Return null if account doesn't exist
 * @param fn
 * @returns
 */
export const tryGetAccount = async <T>(fn: AccountFn<T>) => {
  try {
    return await fn();
  } catch {
    return null;
  }
};

/**
 * Tries to get account based on function fn
 * Return null if account doesn't exist
 * @param fn
 * @returns
 */
export const tryGet = async <T>(fn: () => Promise<T>) => {
  try {
    return await fn();
  } catch {
    return null;
  }
};
